var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Row, Col } from "react-bootstrap";
import InterestTable from "./InterestTable";
import { useSelector } from "react-redux";
import di from "../../../di/serviceLocator";
import Loader from "@frameworks/shared-library/components/Loader";
import { EmptyValidation } from "@domains/utils/commonText";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
var SMTFInterest = function (props) {
    var _a = __read(React.useState(), 2), smtfInterest = _a[0], setSmftInterest = _a[1];
    var _b = __read(React.useState(false), 2), loader = _b[0], setLoader = _b[1];
    var _c = __read(React.useState(), 2), smtfNoDataMsg = _c[0], setSmtfDataMsg = _c[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    function dpcDetails() {
        di.clients
            .getDPCDetails({
            acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
            flag: "2",
        })
            .then(function (resp) {
            if (resp && resp.length > 0) {
                setSmftInterest(resp);
            }
            else {
                setSmftInterest([]);
                setSmtfDataMsg({
                    msg: EmptyValidation.default,
                    show: true,
                    icon: "",
                });
            }
            setLoader(false);
        })
            .catch(function (error) {
            setSmtfDataMsg({
                msg: EmptyValidation.default,
                show: true,
                icon: "",
            });
            setSmftInterest([]);
            setLoader(false);
        });
    }
    React.useEffect(function () {
        if (selectedAcount && selectedAcount.accountCode) {
            setLoader(true);
            dpcDetails();
        }
    }, [selectedAcount]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 px-0 dpledger-block" },
            React.createElement(Row, { className: "px-0 mx-0" },
                React.createElement(Col, { className: "px-0 HeadRow d-flex justify-content-between align-items-center" },
                    React.createElement("span", { className: "DMSansNormal_20_400 txt" },
                        React.createElement("i", { className: "edel-icon-arrow-left1", onClick: function () {
                                props.closePopup(false);
                            } }),
                        "SMTF Interest (%) -\u00A0",
                        React.createElement("strong", { className: "DMSansBold_20_700 " },
                            "Accode :", selectedAcount === null || selectedAcount === void 0 ? void 0 :
                            selectedAcount.accountCode))))),
        React.createElement(Row, { className: "px-0 mx-0 payment-popuptable-block delayed-fno" },
            React.createElement(Row, { className: "mx-0 payment-popuptable-mainhead" },
                React.createElement(Col, { className: "px-0 DMSansMedium_12_500 txt_primaryGrey" }, "Month - Year"),
                React.createElement(Col, { className: "px-0 DMSansMedium_12_500 txt_primaryGrey taRight" }, "Interest Amount (Rs)")),
            React.createElement(Row, { className: "mx-0" },
                React.createElement(React.Fragment, null,
                    loader && (React.createElement("div", { className: "position-relative client-loader" },
                        React.createElement(Loader, null))),
                    !loader && React.createElement(InterestTable, { dpcData: smtfInterest }),
                    React.createElement("div", { className: "Errormsgdiv" }, smtfNoDataMsg && smtfNoDataMsg.show && (React.createElement(Errormsg, { icon: smtfNoDataMsg.icon, msg: smtfNoDataMsg.msg }))))))));
};
export default SMTFInterest;
